import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { SlbcContextProvider } from './context/SlbcContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SlbcContextProvider>
      <App />
    </SlbcContextProvider>
  </React.StrictMode>
)